<template>
  <div class="container news">
    <div class="row news_title">
      <div class="col-12">
        <Title type="news" current-name="Новости">
          Новости
        </Title>
      </div>
    </div>
    <div class="row ">
      <nuxt-link
        v-for="(val, i) in getNewsByCurentPage"
        :key="`news-${ i }`"
        :to="`/news/${ val.id }`"
        class="news__item  col-12 col-md-6"
        no-prefetch
      >
        <CardNews
          :title="val.name"
          :photo="val.image"
          :excerpt="val.subName"
          :date="getFormatedDate(val.date)"
        />
      </nuxt-link>
    </div>
    <div class="row">
      <div class="col-12 news_controls">
        <Button @click="showMore" v-if="isShowMore" class="button_small">
          Показать еще
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import CardNews from '@/components/page/CardNews'
import Button from '@/components/UI/Button'

export default {
  /* head() {
    return {
      title: 'Новости СУШИФОКС',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'В разделе с новостями вы можете получить информацию об обновлении ассортимента, изменениях режима работы и так далее.'
        }
      ]
    }
  }, */
  components: { Title, CardNews, Button },
  data () {
    return {
      pageCounter: 6,
      curentPage: 1,
    }
  },
  computed: {
    getNewsByCurentPage () {
      return this.news.slice(0, this.pageCounter * this.curentPage)
    },
    isShowMore () {
      return (this.pageCounter * this.curentPage) < this.news.length
    },
  },
  async asyncData ({ $axios, store }) {
    try {
      const api = store.getters['api/getNews']
      const res = await $axios.get(api)
      const news = res.data.items

      return {
        news,
      }
    } catch (e) {
      return {
        news: [],
      }
    }
  },
  created () {
    this.$store.commit('changeMenu', this.$route.name)
  },
  methods: {
    showMore () {
      this.curentPage++
      const scrollCounter = (this.pageCounter * this.curentPage) - this.pageCounter - 1

      document.getElementsByClassName('card-news')[scrollCounter].scrollIntoView({
        alignToTop: true,
        behavior: 'smooth',
      })
    },
    getFormatedDate (date) {
      return date.replace(/\-/g, '.')
    },
    getExcerpt (description) {
      return description.substring(300, 0) + (description.length <= 300 ? '' : '...')
    },
  },
}
</script>

<style lang="less">
.news {
	margin-top: 20px;
	&_title {
		margin-bottom: 25px;
	}

	&_controls {
		width: 100%;
		display: flex;
		justify-content: center;
		margin: 40px 0;
	}

	.card-news {
		margin-bottom: 20px;
	}
}
.news__item{
	color: #000;
	text-decoration: none;
}
</style>
